import { RootActionTypes } from '../../../stores/types';
import ActionTypes from '../constants/ActionTypes';

export default function changeSearchValue(value: string): RootActionTypes {
  return {
    type: ActionTypes.CHANGE_SEARCH_VALUE,
    payload: value,
  };
}
